import { useMemo } from "react";
import { makeQueryString } from "core/makeQueryString";
import { useFetchGet } from "hooks/fetch/useFetchGet";
import { CaseStatusTypes } from "interfaces/case-status-type";

/** The object returned from the get case status types hook  */
export type GetCaseStatusTypesResponse = {
  loading: boolean;
  error: boolean;
  caseStatusTypes: CaseStatusTypes[];
  count: number;
};

/** The response returned from the get case status types fetch */
type FetchGetCaseStatusTypesResponse = {
  loading: boolean;
  error: boolean;
  response?: {
    results: CaseStatusTypes[];
    count: number;
  };
  refetch: () => void;
};

export interface useGetCaseStatusTypesArgs {
  /** page the current page, defaults to the first page */
  page?: number;
  /** the size of the page, defaults to 10000 */
  pageSize?: number | string;
  visible?: number;
  ordering?: string | null;
}

export function useGetCaseStatusTypes(
  optional: useGetCaseStatusTypesArgs = {}
): GetCaseStatusTypesResponse {
  const { page = 1, pageSize = "max", visible = 1, ordering = null } = optional;
  const url = useMemo(
    () =>
      `case_status_types` +
      makeQueryString({
        page,
        size: pageSize,
        visible: visible,
        ordering: ordering
      }),
    [page, pageSize, visible, ordering]
  );

  const {
    loading,
    error,
    response = { results: [], count: 0 }
  }: FetchGetCaseStatusTypesResponse = useFetchGet(url);

  return {
    loading,
    error,
    caseStatusTypes: response.results,
    count: response.count
  };
}
